const esLang = {
  title: 'Contacto',
  phones: 'Teléfonos',
  report: 'Reportes',
  reportDesc: 'Reporta un posible efecto secundario',
  reportBtn: 'REPORTA AQUÍ',
  fullname: 'Nombre completo',
  subject: 'Asunto',
  email: 'Correo electrónico',
  comments: 'Comentarios',
  send: 'Enviar',
  terms: 'He leído y acepto',
  privacy: 'Aviso de Privacidad',
  allRequired: '* Todos los campos son obligatorios',
  termsRequired: '* Acepta los terminos y condiciones',
  invalidEmail: '* Correo electrónico no valido',
  captchaIncompleted: '* Completa el captcha',
  sending: 'Enviando...',
  err: '* algo salió mal, inténtelo de nuevo más tarde',
  success: 'Gracias, pronto estaremos en contacto'
}
const enLang = {
  title: 'Contact',
  phones: 'Phones ',
  report: 'Reports',
  reportDesc: 'Resporta un posible efecto secundario',
  reportBtn: 'Reporta aquí',
  fullname: 'Nombre completo',
  subject: 'Asunto',
  email: 'Correo electrónico',
  comments: 'Comentarios',
  send: 'Enviar',
  terms: 'He leído y acepto',
  privacy: 'Aviso de Privacidad',
  allRequired: '* Todos los campos son obligatorios',
  termsRequired: '* Acepta los terminos y condiciones',
  invalidEmail: '* Correo electrónico no valido',
  captchaIncompleted: '* Completa el captcha',
  sending: 'Enviando...',
  err: '* algo salió mal, inténtelo de nuevo más tarde',
  success: 'Gracias, pronto estaremos en contacto'
}

export const langTexts = {
  es: esLang,
  en: enLang
}